<template>
  <div class="myautocustomer">
    <el-autocomplete :size="size" :clearable="true" :hide-loading="true"
                     popper-class="my-autocomplete" ref="droplist1"
                     v-model="myContent"
                     style="width:100%;"
                     prefix-icon="el-icon-search"
                     onfocus="this.select()" :disabled="disabled"
                     :fetch-suggestions="querySearchAsync"
                     :placeholder="placeholder" :select-when-unmatched="true" @clear="clear"
                     @select="handleSelect" :debounce=5>
      <template slot-scope="{ item }">
        <div style="text-overflow: ellipsis;overflow: hidden;font-size: 12px;" :title="item.deptname">{{ item.customerserial }} {{ item.deptname }}  {{ item.shortname }} </div>
        <div style="font-size: 12px;color: #b4b4b4;line-height:20px;">{{ item.linkman }} {{ item.linkmantel }}<el-tag
          :key="tag"  v-for="tag in item.ticket?item.ticket.replace('$',';').split(';'):[]" :disable-transitions="false" size="mini" style="margin-left: 10px" v-if="tag">{{tag}}</el-tag></div>
        <div style="font-size: 12px;line-height:20px;color: #b4b4b4;" v-if="splitByAddress">{{ item.deliveryaddress }}</div>
      </template>
    </el-autocomplete>
    <input type="text" ref="hide1" style="width:0px;height:0px;position:absolute;filter:alpha(opacity:0); opacity:0;  -moz-opacity:0;-khtml-opacity: 0"/>
  </div>
</template>

<script>
  import {getpinyinlistData} from '@/api/set/externaldept';

  export default {
    name: "AutoComplete",
    data() {
      return {
        myContent: this.content,
        pinyinData: [],
      }
    },
    props: {
      content: {//显示的文本
        default:""
      },
      needfocus: {//显示的文本
        default:false
      },
      splitByAddress:{//是否需要根据收货地址拆分多条记录
        default:false
      },
      unitgroup: {//1 表示客户，2表示经销商，3表示供应商
        default: 1
      },
      disabled:{
        default:false
      },
      parentCustomerSerial:{//上级客户编码
        default:""
      },
      settingmenthod:{//200表示月结的客户
        default:""
      },
      placeholder:{//提示文本
         default:'搜索客户，enter键结束'
      },
      size:{//  大小，取值 ""/medium / small / mini
        default:  ""
      }
    },
    methods: {
      init(){
        this.myContent = "";
        this.$nextTick(() => {
          this.$refs.droplist1.focus();
        })
      },
      clearContent() {
        this.myContent = "";
      },
      clear() {//清空
        this.$emit("clear");
      },
      //显示区域显示的列表数据
      querySearchAsync(queryString, cb) {
        cb(this.pinyinData);
      },
      //收货地址排序：先按客户分组(customerserial)，同一客户内默认地址最前、其余按 sort 降序(大的在前)
      sortPinyinData() {
        //先按客户分组，保证同一客户的所有地址连在一起
        var group = {};
        var order = [];
        for (var i = 0; i < this.pinyinData.length; i++) {
          var cs = this.pinyinData[i].customerserial || '';
          if (!group[cs]) {
            group[cs] = [];
            order.push(cs);
          }
          group[cs].push(this.pinyinData[i]);
        }
        //同一客户内排序：默认地址最前，其余按 sort 降序
        var result = [];
        for (var j = 0; j < order.length; j++) {
          var custList = group[order[j]].sort(function (a, b) {
            var ad = (a.defalut == '1' || a.defalut == 1) ? 1 : 0;
            var bd = (b.defalut == '1' || b.defalut == 1) ? 1 : 0;
            if (ad != bd) return bd - ad;
            var asort = a.sort != null && a.sort != '' ? parseInt(a.sort) : 0;
            var bsort = b.sort != null && b.sort != '' ? parseInt(b.sort) : 0;
            if (asort != bsort) return bsort - asort;
            return 0;
          });
          for (var k = 0; k < custList.length; k++) {
            result.push(custList[k]);
          }
        }
        this.pinyinData = result;
      },
      //选中后执行，按enter也触发
      handleSelect(item) {
        if (!item.unitguid) {
          this.$refs.hide1.focus()
          this.bindGrid()
        } else {
          this.myContent = item.deptname
          //处理选中之后的地址session问题
          this.$emit("handleSelect", item.customerserial, item.deptname, item);
        }
      },
      initCus(customerserial){
        this.myContent="";
        this.bindGrid(customerserial);
      },
      bindGrid(customerserial) {
        this.pinyinData = []
        // if (this.myContent.length < 1) {
        //   this.$message({
        //     message: '至少一位',
        //     type: 'warning',
        //     duration: '1500',
        //   })
        //   return
        // }
        getpinyinlistData({
          search: this.myContent.trim().toLocaleLowerCase(),
          unitgroup: this.unitgroup,
          parentcustomerserial: this.parentCustomerSerial,
          settingmenthod: this.settingmenthod,
          splitByAddress: this.splitByAddress ? "1" : "0",
          customerserial: customerserial ? customerserial : ''
        }).then(response => {
          this.pinyinData = response.data.obj
          for (let i = 0; i < this.pinyinData.length; i++) {
            this.pinyinData[i].value = this.pinyinData[i].fpinyin
          }
          this.sortPinyinData();
          if (this.pinyinData.length == 1) {
            this.handleSelect(this.pinyinData[0]);
          } else {
            this.$refs.droplist1.focus()
          }
        }).catch((error) => {
          console.log(error)
        });
      },

    },
    watch: {
      content(val) {
        this.myContent = val;
      }
    },

    mounted() {
      getpinyinlistData({
        search: '',
        unitgroup: this.unitgroup,
        parentcustomerserial: this.parentCustomerSerial,
        settingmenthod: this.settingmenthod,
        splitByAddress: this.splitByAddress ? "1" : "0"
      }).then(response => {
        this.pinyinData = response.data.obj
        for (let i = 0; i < this.pinyinData.length; i++) {
          this.pinyinData[i].value = this.pinyinData[i].fpinyin
        }
        this.sortPinyinData();
        if (this.needfocus)
          this.$refs.droplist1.focus()
      }).catch((error) => {
        console.log(error)
      });
      // this.$nextTick(() => {
      // })
    }

  }
</script>

<style>
  .my-autocomplete{
    min-width:460px !important;
  }
  .my-autocomplete .el-autocomplete-suggestion__wrap{
    max-height: 400px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/AutoCustomer.vue